module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/LK-96fdc9231b4b1de9fda1ec4603c0392e.png";